import * as sanitizeHTML from "sanitize-html"
import { Alignment, GetImageProps, GetCtaProps, GetHtmlProps } from "./types"

export const getHtml = (contentNode: GetHtmlProps | undefined) =>
  contentNode?.childMarkdownRemark?.html

export function getImage(imgNode: GetImageProps | undefined) {
  return imgNode?.file?.url
}
export function getCtas(content: GetCtaProps) {
  const { ctas = [] } = content

  return ctas?.map(cta => ({ title: cta.anchorText, to: cta.href })) ?? []
}

/*
  Primarily used with flexbox to align content based on the given Alignment value.
  aligns:
    - text
    - content
    - content start position
  if not in a flex/grid container this will just align the text
  TODO: make this even more generic so we can use it in more places
*/
export const alignmentStyles = (alignment: Alignment) => {
  switch (alignment) {
    case Alignment.Left:
      return {
        justifyContent: `flex-start`,
        textAlign: Alignment.Left,
        alignItems: `flex-start`,
      }
    case Alignment.Right:
      return {
        justifyContent: `flex-end`,
        textAlign: Alignment.Right,
        alignItems: "flex-end",
      }
    default:
      return {
        alignItems: "center",
        justifyContent: "center",
        textAlign: Alignment.Center,
      }
  }
}

// This set of HTML tags are derived from the resulting output of
// all the possible rich text options in Contentful's rich text editor.
// The intent was to create a 1:1 mapping of what content editors can do
// with that editor and what markup our SSLP components will support
const defaultSSLPAllowedTags = [
  "a",
  "p",
  "br",
  "em",
  "strong",
  "b",
  "ul",
  "ol",
  "li",
  "h1",
  "h2",
  "h3",
  "del",
  "table",
  "thead",
  "tbody",
  "td",
  "th",
  "tr",
  "blockquote",
  "hr",
  "code",
]

export const getSSLPSanitizedHtml = (
  htmlContent: string,
  sanitizeHtmlOptions = {}
) =>
  sanitizeHTML(htmlContent, {
    allowedTags: defaultSSLPAllowedTags,
    ...sanitizeHtmlOptions,
  })
